export enum InvoicingType {
  REGULAR = 'REGULAR',
  COMMISSION = 'COMMISSION',
  COMPANY_REGULAR = 'COMPANY_REGULAR',
  COMPANY_INVOICE = 'COMPANY_INVOICE',
  COMPANY_BULK_INVOICE = 'COMPANY_BULK_INVOICE',
  INSURANCE = 'INSURANCE',
  AGENCY = 'AGENCY',
  AGENCY_BULK = 'AGENCY_BULK_INVOICE',
}
